import { Heading } from '../Heading/Heading'
import { Textarea } from './Textarea'
import { TEXTAREA_SIZE } from './Textarea.constants'

export const TextareaPresentation = () => {
  /* *** Textarea *** */

  const renderTextarea = () =>
    TEXTAREA_SIZE.map(size => (
      <Textarea
        charactersCount={20}
        className="ms-6"
        isFilled
        maxLength={100}
        onChange={() => null}
        showCounter
        size={size}
      />
    ))
  /* *** Textarea Disabled *** */

  const renderTextareaDisabled = () =>
    TEXTAREA_SIZE.map(size => (
      <Textarea
        charactersCount={20}
        className="ms-6"
        disabled
        isFilled
        maxLength={100}
        onChange={() => null}
        showCounter
        size={size}
      />
    ))

  return (
    <div>
      <Heading size={4}>Textarea:</Heading>
      {/* *** Textarea *** */}

      <div className="d-flex pt-4 ms-n4">{renderTextarea()}</div>

      {/* *** Textarea Disabled *** */}

      <div className="d-flex pt-4 ms-n4">{renderTextareaDisabled()}</div>
    </div>
  )
}
